// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USERLOGGED_IN = 'SET_USERLOGGED_IN';
export const SET_USER = 'SET_USER';
export const SET_USERS = 'SET_USERS';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const LOADING_USER = 'LOADING_USER';
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ';
export const UPDATE_USER = 'UPDATE_USER';
export const FOLLOW_USER = 'FOLLOW_USER';
export const UNFOLLOW_USER = 'UNFOLLOW_USER';
export const USER_DELETED = 'USER_DELETED';

export type User = {
  _id: String;
  firstName: String;
  lastName: String;
  description: String;
  email: String;
  branch: String;
};
